import { render, staticRenderFns } from "./giftticket.vue?vue&type=template&id=e60822e0&scoped=true&"
import script from "./giftticket.vue?vue&type=script&lang=js&"
export * from "./giftticket.vue?vue&type=script&lang=js&"
import style0 from "./giftticket.vue?vue&type=style&index=0&id=e60822e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60822e0",
  null
  
)

export default component.exports